export const classes = {
  bottom: {
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    justifyContent: 'end',
    display: 'flex',
  },
  legalNotes: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
};
